/**
 * Leaf module: the opt-in class names, and nothing else.
 *
 * A file that only needs the class string must not pull in the scope component with it - that drags
 * createGlobalStyle, the styles barrel and the LineProgressBar styled components into every module
 * graph that mentions a dark modal, which is enough to break suites that stub styled-components
 * narrowly. Import the component from the folder; import these from here. PLA-8844.
 */
export const DARK_MODAL_CLASS = 'perx-dark-modal';
